import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { fs } from "../../theme/designLintTokens";
const NAV_RADIUS = 10;
const NAV_TRANSITION_MS = 200;
const NavItem = ({
  label,
  icon,
  selected,
  onClick,
  collapsed = false
}) => {
  const theme = useTheme();
  const navTransition = theme.transitions.create(['background-color', 'color', 'box-shadow'], {
    duration: NAV_TRANSITION_MS,
    easing: theme.transitions.easing.easeInOut
  });
  const defaultColor = theme.palette.text.secondary;
  const defaultIcon = theme.palette.text.secondary;
  const hoverBg = theme.palette.action.hover;
  const activeBg = theme.palette.ef?.accentSurface;
  const activeText = theme.palette.ef?.accent;
  const activeIcon = theme.palette.ef?.accent;
  const button = <ListItemButton onClick={onClick} selected={selected} disableRipple sx={{
      py: 1.25,
      px: collapsed ? 0.5 : 2,
      borderRadius: `${NAV_RADIUS}px`,
      transition: navTransition,
      color: selected ? activeText : defaultColor,
      boxShadow: 'none',
      justifyContent: collapsed ? 'center' : 'flex-start',
      '&.Mui-selected': {
        backgroundColor: activeBg,
        color: activeText,
        '&:hover': {
          backgroundColor: activeBg
        }
      },
      '&:hover': {
        backgroundColor: selected ? activeBg : hoverBg,
        boxShadow: 'none'
      }
    }}>
        <ListItemIcon sx={{
        minWidth: 40,
        color: selected ? activeIcon : defaultIcon,
        transition: navTransition,
        justifyContent: 'center'
      }}>
          {icon}
        </ListItemIcon>
        {!collapsed && <ListItemText primary={label} primaryTypographyProps={{
        variant: 'body2',
        fontWeight: selected ? 600 : 500,
        fontSize: fs.s_n0_875rem,
        lineHeight: 1.5,
        sx: {
          color: 'inherit',
          transition: navTransition
        }
      }} />}
      </ListItemButton>;

  return <ListItem disablePadding sx={{
    mb: 0.75
  }}>
      {collapsed ? <Tooltip title={label} placement="right" arrow>{button}</Tooltip> : button}
    </ListItem>;
};
export default NavItem;
